import React, { useReducer, useState, useRef, useEffect } from "react";
import dayjs from "dayjs";
import { AiOutlineArrowLeft } from "react-icons/ai";
import styles from "./register.module.css";
import { Link, useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Avatar } from "@mui/material";
// import { MuiFileInput } from "mui-file-input";
import { ImSpinner9 } from "react-icons/im";
import logo from "../../assets/logo.png";
import defaultPhoto from "../../assets/defaultPhoto.png";
import axios from "axios";
import Swal from "sweetalert2";
import { apiBaseURL } from "../../utils/axios";
import { useDispatch } from "react-redux";
import {
  dispatchIsLogged,
  dispatchUserToken,
  dispatchUserId,
} from "../../utils/redux/userSlice.js";
import { FiCamera } from "react-icons/fi";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  TextField,
  MenuItem,
  IconButton,
  OutlinedInput,
  InputLabel,
  InputAdornment,
  FormControl,
} from "@mui/material";
import { FormControlLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { countries } from "../../components/_mock/_countries";
import { Helmet } from "react-helmet";
import nigeriaStates from "./nigeriaStates.json";
import bloodSample from "./bloodSample.json";
import genderType from "./genderType.json";
import genotype from "./genotype.json";

const trueDate = new Date();
const maxDate = trueDate.setFullYear(trueDate.getFullYear() - 18);

const initialState = {
  openTab: 2,
  forgetPassword: false,
  recoverEmail: "",
  showPassword: false,
  profilePicture: null,
  loading: false,
  imageLoading: false,
  firstName: "",
  lastName: "",
  gender: "",
  phone: "",
  bloodType: "",
  genotype: "",
  country: "",
  address: "",
  state: "",
  city: "",
  email: "",
  password: "",
  dateOfBirth: maxDate,
  userChecked: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_OPEN_TAB":
      return { ...state, openTab: action.payload };
    case "SET_FORGET_PASSWORD":
      return { ...state, forgetPassword: action.payload };
    case "SET_RECOVER_EMAIL":
      return { ...state, recoverEmail: action.payload };
    case "TOGGLE_SHOW_PASSWORD":
      return { ...state, showPassword: !state.showPassword };
    case "SET_PROFILE_PICTURE":
      return { ...state, profilePicture: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_IMAGE_LOADING":
      return { ...state, imageLoading: action.payload };
    case "SET_FIRST_NAME":
      return { ...state, firstName: action.payload };
    case "SET_LAST_NAME":
      return { ...state, lastName: action.payload };
    case "SET_GENDER":
      return { ...state, gender: action.payload };
    case "SET_PHONE":
      return { ...state, phone: action.payload };
    case "SET_BLOOD_TYPE":
      return { ...state, bloodType: action.payload };
    case "SET_GENOTYPE":
      return { ...state, genotype: action.payload };
    case "SET_COUNTRY":
      return { ...state, country: action.payload };
    case "SET_ADDRESS":
      return { ...state, address: action.payload };
    case "SET_STATE":
      return { ...state, state: action.payload };
    case "SET_CITY":
      return { ...state, city: action.payload };
    case "SET_EMAIL":
      return { ...state, email: action.payload };
    case "SET_PASSWORD":
      return { ...state, password: action.payload };
    case "SET_DATE_OF_BIRTH":
      return { ...state, dateOfBirth: action.payload };
    case "SET_USER_CHECKED":
      return { ...state, userChecked: action.payload };
    default:
      return state;
  }
};

export default function Authentication() {
  const [state, dispatch] = useReducer(reducer, initialState);

  // Image error Upload
  const [imgError, setImgError] = useState(false);
  const imgErrorRef = useRef(null);

  // Dispatch Login
  const dispatchLogin = useDispatch();

  const navigateTo = useNavigate();

  useEffect(() => {
    if (imgErrorRef.current.value !== "") {
      setImgError(false);
    }
  }, [state.profilePicture]);

  const forgotPasswordModal = () => {
    dispatch({ type: "SET_FORGET_PASSWORD", payload: true });
  };

  // Handles Forgot Password Function
  const handleSubmitForgotPassword = async (e) => {
    e.preventDefault();

    if (state.recoverEmail === "") {
      Swal.fire({
        icon: "warning",
        text: "Make sure you enter an email",
      });
      return false;
    } else {
      try {
        const userData = {
          email: state.recoverEmail,
        };

        const response = await axios.post(
          `${apiBaseURL}/v1/donors/forgot-password`,
          userData
        );

        dispatch({ type: "SET_FORGET_PASSWORD", payload: false });
        // console.log(response);

        // Display success message and navigate after confirmation
        Swal.fire({
          icon: "success",
          title: `Success...`,
          text: `${response.data.message}`,
        }).then((result) => {
          if (result.isConfirmed) {
            return navigateTo("/auth");
          }
        });
      } catch (err) {
        // Display error message
        return Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `${err.response.data.message}`,
        });
      }
    }
  };

  // Handles Login Function
  const handlesLoginSubmit = async (e) => {
    e.preventDefault();
    const data = {
      email: state.email,
      password: state.password,
    };
    dispatch({ type: "SET_LOADING", payload: true });

    try {
      const response = await axios.post(`${apiBaseURL}/v1/auth/login`, data);
      dispatchLogin(dispatchIsLogged());
      dispatchLogin(dispatchUserToken(response.data.token));
      dispatchLogin(dispatchUserId(response.data.user.userId));
      navigateTo("/dashboard");
      Swal.fire({
        icon: "success",
        title: "Login Successful",
        text: `Welcome back ${response.data.user?.firstname}`,
      });
      return navigateTo("/dashboard");
    } catch (error) {
      if (error.response.data.msg === "Your account has not been verified") {
        dispatch({ type: "SET_LOADING", payload: false });

        Swal.fire({
          icon: "info",
          title: "Verification Not Completed",
          text: `Your account has not been verified. Please check your email for verification link to verify your account`,
        });
      } else if (error.message === "Network Error") {
        dispatch({ type: "SET_LOADING", payload: false });

        Swal.fire({
          icon: "error",
          title: "Network Error",
          text: `Please check your network and try again`,
        });
      } else {
        dispatch({ type: "SET_LOADING", payload: false });
        return Swal.fire({
          icon: "error",
          title: "Email or Password input is wrong",
          text: `Please enter the right email or password`,
        });
      }
    }
  };

  // Handles Image Upload Function
  const handleUpload = async (e) => {
    e.preventDefault();

    dispatch({ type: "SET_IMAGE_LOADING", payload: true });

    try {
      const file = e.target.files[0];

      const fileSize = e.target.files[0].size;

      if (fileSize > 500000) {
        Swal.fire({
          icon: "info",
          text: "Profile Image must be below 500KB",
        });
        dispatch({ type: "SET_IMAGE_LOADING", payload: false });

        return false;
      } else if (file) {
        const newImage = new FormData();
        newImage.append("file", file);
        newImage.append("upload_preset", "ribiBlood");

        axios
          .post(
            "https://api.cloudinary.com/v1_1/ribi-blood/image/upload",
            newImage
          )
          .then((res) => {
            dispatch({ type: "SET_PROFILE_PICTURE", payload: res.data.url });
            // console.log(res.data);
            dispatch({ type: "SET_IMAGE_LOADING", payload: false });
          });
      }
    } catch (error) {
      dispatch({ type: "SET_IMAGE_LOADING", payload: false });

      // console.log(error);
    }
  };

  // Handles Registration Function
  const handleRegisterSubmit = async (e) => {
    e.preventDefault();

    dispatch({ type: "SET_LOADING", payload: true });

    const userData = {
      avater: state.profilePicture,
      firstname: state.firstName,
      lastname: state.lastName,
      gender: state.gender,
      dateOfBirth: state.dateOfBirth.toString(),
      phone: state.phone,
      bloodType: state.bloodType,
      genotype: state.genotype,
      country: state.country,
      donorLocation: state.address,
      state: state.state,
      city: state.city,
      email: state.email,
      password: state.password,
    };

    if (state.profilePicture === null) {
      // Focus the user
      imgErrorRef.current.focus();

      // Scroll Up
      window.scrollTo({
        top: 0,
        behaviour: "smooth",
      });
      // Display the error message
      setImgError(true);
      return false;
    } else {
      setImgError(false);
    }

    try {
      // Make a POST request to register user data
      const response = await axios.post(
        `${apiBaseURL}/v1/auth/register`,
        userData
      );
      // console.log("checking response", response);

      // Handle successful registration
      // handlesBackToLogin();
      navigateTo("/");
      dispatch({ type: "SET_LOADING", payload: false });
      Swal.fire({
        icon: "success",
        title: "To complete your registration",
        text: `Kindly check your email ${userData.email} for verification link`,
      });
    } catch (error) {
      // Handle registration error
      dispatch({ type: "SET_LOADING", payload: false });

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error.response.data.msg}`,
      });
    }
  };

  return (
    <section>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Login-Register | RIBI BLOOD</title>
        <link rel="canonical" href="https://ribiblood.com/auth" />
      </Helmet>
      <div className="mx-auto">
        <div className="flex items-center lg:justify-center justify-center">
          <Link
            to="/"
            className={`flex items-center lg:justify-center justify-center mt-8 max-w-min hover:scale-110`}
          >
            <img
              src={logo}
              alt="Ribi logo"
              className={`${styles.logoImg} w-6 hover:animate-bounce`}
            />
            <p className={`${styles.logoText} hover:animate-bounce`}>RIBI</p>
          </Link>
        </div>
        <div className="sm:container mx-auto mt-12">
          <div className="flex flex-col items-center justify-center ">
            <ul className="flex space-x-2">
              <li>
                <button
                  onClick={() => dispatch({ type: "SET_OPEN_TAB", payload: 1 })}
                  className={` ${
                    state.openTab === 1 ? " bg-red-500 text-slate-100" : ""
                  } inline-block px-4 py-2 text-black  rounded shadow hover:bg-red-400 hover:text-white`}
                >
                  Login
                </button>
              </li>
              <li>
                <button
                  onClick={() => dispatch({ type: "SET_OPEN_TAB", payload: 2 })}
                  className={` ${
                    state.openTab === 2 ? " bg-red-500 text-slate-100" : ""
                  } inline-block px-4 py-2 text-black  rounded shadow hover:bg-red-400 hover:text-white`}
                >
                  Register
                </button>
              </li>
            </ul>
            <div className="p-3 mt-8 bg-white border mb-8">
              <div className={state.openTab === 1 ? "block" : "hidden"}>
                {/* --------------------------------------Login ----------------------------------- */}{" "}
                <div>
                  <div className="">
                    <div className={`grid grid-cols-1 mb-8`}>
                      <div
                        className={`px-8 sm:px-16 md:px-16 lg:px-32 xl:px-48 2xl:px-56 py-6`}
                      >
                        <div className="my-4 text-3xl mb-10 p-3 flex justify-center items-center text-center gap-4">
                          <p className="text-slate-700">Hello, Welcome back</p>
                        </div>
                        <form
                          onSubmit={handlesLoginSubmit}
                          className={styles.form}
                        >
                          <div className="mb-4">
                            <FormControl
                              sx={{ width: 380, maxWidth: "100%" }}
                              variant="outlined"
                            >
                              <InputLabel htmlFor="outlined-adornment-email">
                                Email *
                              </InputLabel>
                              <OutlinedInput
                                id="outlined-adornment-email"
                                type="email"
                                value={state.email}
                                onChange={(e) =>
                                  dispatch({
                                    type: "SET_EMAIL",
                                    payload: e.target.value,
                                  })
                                }
                                label="Email"
                                required
                              />
                            </FormControl>
                          </div>
                          <div className="mb-4">
                            <FormControl
                              sx={{ width: 380, maxWidth: "100%" }}
                              variant="outlined"
                            >
                              <InputLabel htmlFor="outlined-adornment-password">
                                Password
                              </InputLabel>
                              <OutlinedInput
                                id="outlined-adornment-password"
                                type={state.showPassword ? "text" : "password"}
                                value={state.password}
                                onChange={(e) =>
                                  dispatch({
                                    type: "SET_PASSWORD",
                                    payload: e.target.value,
                                  })
                                }
                                label="Password"
                                required
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={() =>
                                        dispatch({
                                          type: "TOGGLE_SHOW_PASSWORD",
                                        })
                                      }
                                      edge="end"
                                    >
                                      {state.showPassword ? (
                                        <Visibility />
                                      ) : (
                                        <VisibilityOff />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          </div>
                          <div className="flex justify-center items-center">
                            {state.loading ? (
                              <button
                                className={`my-2 py-4 px-8 bg-[gray] flex items-center justify-center rounded-full text-white text-[14px] font-bold w-64 cursor-not-allowed hover:opacity-75`}
                              >
                                <ImSpinner9
                                  size={20}
                                  className="animate-spin mr-2"
                                />
                                Login
                              </button>
                            ) : (
                              <button
                                className={`my-2 py-4 px-8 bg-[#f6655f] rounded-full text-white text-[14px] font-bold w-64 hover:opacity-75`}
                              >
                                Login
                              </button>
                            )}
                          </div>
                          <div className="flex flex-col gap-y-4 lg:flex-row justify-center items-center mt-5 mb-5">
                            <span className={`${styles}.forgot`}>
                              <p
                                onClick={forgotPasswordModal}
                                className="hover:text-[#f6655f] cursor-pointer"
                              >
                                Forget Password?
                              </p>
                            </span>
                          </div>
                        </form>
                      </div>
                    </div>
                    {/* --------------------------------------- Forgot Password ------------------------------------ */}
                    {state.forgetPassword && (
                      <section>
                        <section className="fixed top-0 left-0 w-screen flex justify-center items-center my-0 mx-auto bg-slate-100 z-50 h-screen">
                          <div className="w-full lg:max-w-lg max-w-sm bg-white shadow-lg lg:m-0 mx-[20px] py-12 px-10 rounded-lg">
                            <div
                              className={`flex items-center justify-center mb-6`}
                            >
                              <div
                                className={`flex gap-2 items-center justify-center`}
                              >
                                <img
                                  src={logo}
                                  alt="Ribi logo"
                                  className="w-[20%]"
                                />
                                <p className={styles.logoText}>RIBI</p>
                              </div>
                            </div>
                            <div className="text-center text-3xl mb-4">
                              <p className="text-slate-700">Recover Password</p>
                            </div>
                            <form
                              onSubmit={handleSubmitForgotPassword}
                              className={styles.form}
                            >
                              <div className="mb-4">
                                <TextField
                                  fullWidth
                                  id="outlined-recover-email"
                                  label="Email"
                                  variant="outlined"
                                  value={state.recoverEmail}
                                  onChange={(e) =>
                                    dispatch({
                                      type: "SET_RECOVER_EMAIL",
                                      payload: e.target.value,
                                    })
                                  }
                                  required
                                />
                              </div>
                              <div className="flex justify-center items-center">
                                <button
                                  className={`my-2 py-4 px-8 bg-[#f6655f] rounded-full text-white text-[14px] font-bold w-64 hover:opacity-75`}
                                >
                                  Submit
                                </button>
                              </div>
                              <div className="flex gap-y-4 lg:flex-row justify-center items-center mt-5 mb-5 hover:text-[#f6655f]">
                                <AiOutlineArrowLeft className="mr-2" />
                                <span
                                  onClick={() => {
                                    dispatch({
                                      type: "SET_FORGET_PASSWORD",
                                      payload: false,
                                    });
                                  }}
                                  className=" cursor-pointer"
                                >
                                  Back to Login
                                </span>
                              </div>
                            </form>
                          </div>
                        </section>
                      </section>
                    )}
                  </div>
                </div>
              </div>
              <div className={state.openTab === 2 ? "block" : "hidden"}>
                {/* ------------------------------------ Register ------------------------------------- */}
                <div>
                  <div
                    className={`grid grid-cols-1 mb-8 justify-center items-center`}
                  >
                    <div className={`px-8 sm:px-16 md:px-16 lg:px-32 py-6`}>
                      <div className="text-center text-3xl my-4 flex justify-center items-center gap-4">
                        <p className="text-slate-700">Ready to Donate!</p>
                      </div>
                      <form
                        onSubmit={handleRegisterSubmit}
                        className={styles.form}
                      >
                        {/* -----------------------------check img--------------------------------- */}
                        <section className="text-center mb-10">
                          <div className="flex items-center justify-center text-transparent object-center relative mb-1">
                            <Avatar
                              alt="User Profile"
                              style={{ position: "absolute" }}
                              src={
                                !state.profilePicture
                                  ? defaultPhoto
                                  : state.profilePicture
                              }
                              sx={{ width: 100, height: 100 }}
                              onError={(event) => {
                                event.target.src =
                                  "https://180dc.org/wp-content/uploads/2022/04/Blank-Avatar-300x262.png";
                                event.onerror = null;
                              }}
                            />
                            {state.imageLoading &&
                              imgErrorRef.current.value !== "" && (
                                <ImSpinner9
                                  size={40}
                                  className="animate-spin absolute backdrop-brightness-50-sm z-40 text-red-600"
                                />
                              )}

                            <label
                              htmlFor="fusk"
                              className="cursor-pointer inline-flex px-6 font-bold z-[1000] p-8 w-[100px] h-[100px] rounded-full hover:text-white text-sm hover:bg-[#00000080] uppercase transition duration-150 ease-in-out place-items-center"
                            >
                              <FiCamera className="text-2xl mr-1" /> Edit
                            </label>
                            {/* <TextField
                              style={{ display: "none" }}
                              type="file"
                              value={state.profilePicture}
                              onChange={handleUpload}
                              required
                            /> */}
                            <input
                              style={{ display: "none" }}
                              ref={imgErrorRef}
                              type="file"
                              accept="image/*, capture=camera "
                              id="fusk"
                              onChange={handleUpload}
                              // required
                            />
                          </div>
                          {imgError && (
                            <p className="text-red-500 animate-pulse">
                              Kindly Upload a Profile Image
                            </p>
                          )}
                        </section>

                        <div
                          className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4`}
                        >
                          <TextField
                            fullWidth
                            label="First Name"
                            variant="outlined"
                            value={state.firstName}
                            onChange={(e) =>
                              dispatch({
                                type: "SET_FIRST_NAME",
                                payload: e.target.value,
                              })
                            }
                            required
                          />
                          <TextField
                            fullWidth
                            label="Last Name"
                            value={state.lastName}
                            onChange={(e) =>
                              dispatch({
                                type: "SET_LAST_NAME",
                                payload: e.target.value,
                              })
                            }
                            required
                          />
                          <TextField
                            fullWidth
                            select
                            label="Gender"
                            defaultValue=""
                            value={state.gender}
                            onChange={(e) =>
                              dispatch({
                                type: "SET_GENDER",
                                payload: e.target.value,
                              })
                            }
                            required
                          >
                            {genderType.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </TextField>
                          <TextField
                            fullWidth
                            value={state.phone}
                            label="Phone Number"
                            onChange={(e) =>
                              dispatch({
                                type: "SET_PHONE",
                                payload: e.target.value,
                              })
                            }
                            required
                          />

                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            className="p-0"
                          >
                            <DemoContainer
                              components={["DatePicker"]}
                              className="p-0"
                            >
                              <DatePicker
                                fullWidth
                                disableFuture={true}
                                maxDate={dayjs(maxDate)}
                                label="Date of Birth"
                                value={dayjs(state.dateOfBirth)}
                                onChange={(newValue) =>
                                  dispatch({
                                    type: "SET_DATE_OF_BIRTH",
                                    payload: newValue,
                                  })
                                }
                              />
                            </DemoContainer>
                          </LocalizationProvider>

                          <TextField
                            fullWidth
                            select
                            label="Blood Type"
                            value={state.bloodType}
                            onChange={(e) =>
                              dispatch({
                                type: "SET_BLOOD_TYPE",
                                payload: e.target.value,
                              })
                            }
                            required
                          >
                            {bloodSample.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </TextField>
                          <TextField
                            fullWidth
                            select
                            defaultValue=""
                            label="Genotype"
                            variant="outlined"
                            value={state.genotype}
                            onChange={(e) =>
                              dispatch({
                                type: "SET_GENOTYPE",
                                payload: e.target.value,
                              })
                            }
                            required
                          >
                            {genotype.map((option) => (
                              <MenuItem
                                key={option.value}
                                value={option.value}
                                className="uppercase"
                              >
                                {option.label}
                              </MenuItem>
                            ))}
                          </TextField>
                          <TextField
                            fullWidth
                            select
                            defaultValue=""
                            label="Country"
                            variant="outlined"
                            value={state.country}
                            onChange={(e) =>
                              dispatch({
                                type: "SET_COUNTRY",
                                payload: e.target.value,
                              })
                            }
                            required
                          >
                            {countries.map((option) => (
                              <MenuItem key={option.code} value={option.label}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </TextField>
                          {/* New State */}
                          <TextField
                            fullWidth
                            select
                            label="State"
                            value={state.state}
                            onChange={(e) =>
                              dispatch({
                                type: "SET_STATE",
                                payload: e.target.value,
                              })
                            }
                            required
                          >
                            {nigeriaStates.map((option) => (
                              <MenuItem key={option.id} value={option.name}>
                                {option.name}
                              </MenuItem>
                            ))}
                          </TextField>
                          {/* New State */}

                          <TextField
                            fullWidth
                            label="City"
                            value={state.city}
                            onChange={(e) =>
                              dispatch({
                                type: "SET_CITY",
                                payload: e.target.value,
                              })
                            }
                            required
                          />
                          <TextField
                            fullWidth
                            label="Address"
                            value={state.address}
                            onChange={(e) =>
                              dispatch({
                                type: "SET_ADDRESS",
                                payload: e.target.value,
                              })
                            }
                            required
                          />
                          <TextField
                            fullWidth
                            label="Email"
                            value={state.email}
                            onChange={(e) =>
                              dispatch({
                                type: "SET_EMAIL",
                                payload: e.target.value,
                              })
                            }
                            required
                          />

                          <FormControl fullWidth variant="outlined">
                            <InputLabel htmlFor="outlined-adornment-password">
                              Password
                            </InputLabel>
                            <OutlinedInput
                              id="outlined-adornment-password"
                              type={state.showPassword ? "text" : "password"}
                              value={state.password}
                              onChange={(e) =>
                                dispatch({
                                  type: "SET_PASSWORD",
                                  payload: e.target.value,
                                })
                              }
                              label="Password"
                              required
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() =>
                                      dispatch({
                                        type: "TOGGLE_SHOW_PASSWORD",
                                      })
                                    }
                                    edge="end"
                                  >
                                    {state.showPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />
                          </FormControl>
                        </div>
                        <div className="my-4">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={state.userChecked}
                                required
                                onChange={(e) =>
                                  dispatch({
                                    type: "SET_USER_CHECKED",
                                    payload: e.target.checked,
                                  })
                                }
                                name="checkedB"
                                color="primary"
                              />
                            }
                            // label="I agree to the Terms of Service and Privacy Policy"
                          />
                          <span className="">
                            I agree to the
                            <Link
                              to="/privacy"
                              className="ml-1 hover:underline text-red-400"
                            >
                              Terms of Service, Privacy Policy and User
                              Agreement.
                            </Link>
                          </span>
                        </div>

                        <div className="flex justify-center items-center">
                          {state.loading && !imgError ? (
                            <button
                              className={`my-2 py-4 px-8 bg-[gray] flex items-center justify-center rounded-full text-white text-[14px] font-bold w-64 cursor-not-allowed hover:opacity-75`}
                            >
                              <ImSpinner9
                                size={20}
                                className="animate-spin mr-2"
                              />
                              Register
                            </button>
                          ) : (
                            <button
                              className={`my-2 py-4 px-8 bg-[#f6655f] rounded-full text-white text-[14px] font-bold w-64 hover:opacity-75`}
                            >
                              Register
                            </button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
